export const BASEURL = "https://my-chat-app-backend-fho0.onrender.com";

// localhost ----> http://localhost:5001
// vercel ----> https://my-chat-app-backend.vercel.app
// render ----> https://my-chat-app-backend-fho0.onrender.com